/* eslint-disable */
import local from './config.local.json';
import testing from './config.test.json';
import production from './config.prod.json';

const config = {
  local,
  testing,
  production,
};

config['local'].getBlobUrl = tenantId => `https://konsultacjejst.blob.core.windows.net/attachments-${tenantId}/`;
config['testing'].getBlobUrl = tenantId => `https://konsultacjejst.blob.core.windows.net/attachments-${tenantId}/`;
config['production'].getBlobUrl = tenantId => `https://konsultacjejst.blob.core.windows.net/attachments-${tenantId}/`;

config['local'].host = window.location.host.toLowerCase();
config['testing'].host = window.location.host.toLowerCase();
config['production'].host = window.location.host.toLowerCase();

export default config[window.env.APP_ENV];


// WEBPACK FOOTER //
// ./src/config/index.js